// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__25DXE","colMaxWidth":"Table_colMaxWidth__1-tP0"};